import { CopyButton } from "./CopyButton";
import { useDarkMode } from "../../hooks/useDarkMode";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import vscDarkPlus from "react-syntax-highlighter/dist/esm/styles/prism/vsc-dark-plus";
import vs from "react-syntax-highlighter/dist/esm/styles/prism/vs";

interface CodeSnippetWithCopyProps {
  code: string;
  label: string;
  ariaLabel: string;
  language?: string;
  showSyntaxHighlighting?: boolean;
  fontSize?: string;
}

export function CodeSnippetWithCopy({
  code,
  label,
  ariaLabel,
  language = "hcl",
  showSyntaxHighlighting = false,
  fontSize = "0.75rem",
}: CodeSnippetWithCopyProps) {
  const { isDark } = useDarkMode();

  return (
    <div className="mb-4">
      <label className="block text-sm font-semibold mb-2">{label}</label>
      <div className="relative">
        <div className="absolute top-2 right-2 z-10">
          <CopyButton text={code} ariaLabel={ariaLabel} />
        </div>
        {showSyntaxHighlighting ? (
          <SyntaxHighlighter
            language={language}
            style={isDark ? vscDarkPlus : vs}
            customStyle={{
              margin: 0,
              padding: "0.75rem",
              paddingRight: "3rem",
              background: "transparent",
              borderRadius: "0.5rem",
              border: "1px solid",
              borderColor: isDark ? "rgb(63 63 70)" : "rgb(229 231 235)",
            }}
            className="bg-gray-50 dark:bg-zinc-800"
            codeTagProps={{
              style: {
                fontSize,
                background: "transparent",
                fontFamily:
                  "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
              },
            }}
          >
            {code}
          </SyntaxHighlighter>
        ) : (
          <pre className="p-3 pr-12 bg-gray-50 dark:bg-zinc-800 rounded-lg border border-gray-200 dark:border-zinc-700 overflow-x-auto">
            <code
              className="text-sm font-mono text-gray-800 dark:text-gray-200"
              style={{ padding: 0 }}
            >
              {code}
            </code>
          </pre>
        )}
      </div>
    </div>
  );
}
